module.exports = __webpack_public_path__ + "img/error.18f61b90.png";